import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import OfficetoNutshellRegular from './officeto-nutshell-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    if (validProps.width && validProps.height) {
        delete validProps.height;
    }

    return <OfficetoNutshellRegular {...validProps} />;
}
SvgComponent.iconName = 'officetoNutshellRegular';

export const OfficetoNutshellRegularIcon = svgIconWrapper(SvgComponent);
